<template>
	<header class="header">
		<Nav></Nav>
		<div class="content">
			<h3>快速响应，一站式解决方案</h3>
			<p>用技术为客户创造价值</p>
		</div>
	</header>
	<div class="customization">
		<h3>系统定制开发，一站式解决方案服务商</h3>
		<div class="content">
			<div class="left">
				<h4>移动软件定制开发</h4>
				<h2>切合业务需求，打造极致互联网产品</h2>
				<p>
					专业的技术团队，强大的技术开发实力，针对不同企业的差异化需求，提供个性化、精细化解决方案，提高企业经济效益。
				</p>
				<h5>专业的服务，创造有影响力的产品</h5>
				<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/dingzilogo.png" alt="" />
			</div>
			<div class="right">
				<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/3lian.png" alt="" />
			</div>
		</div>
	</div>
	<div class="technology">
		<h2>十五年技术沉淀，只为敲好每一行代码</h2>
		<p>
			原创开发 &nbsp; | &nbsp; 免费维护 &nbsp; | &nbsp; 快速启动 &nbsp; | &nbsp;
			轻松落地
		</p>
		<div class="content">
			<div>
				<h1>一</h1>
				<h3>多样化营销模式</h3>
				<ul>
					<li>三级分销</li>
					<li>秒杀</li>
					<li>拼团</li>
					<li>预售</li>
				</ul>
			</div>
			<div>
				<h1>一</h1>
				<h3>多样化支付</h3>
				<ul>
					<li>微信</li>
					<li>支付宝</li>
					<li>银联</li>
					<li>paypal</li>
				</ul>
			</div>
			<div>
				<h1>一</h1>
				<h3>直播+购物</h3>
				<ul>
					<li>购物车</li>
					<li>订单</li>
					<li>积分商城</li>
					<li>...</li>
				</ul>
			</div>
			<div>
				<h1>一</h1>
				<h3>数据统计</h3>
				<ul>
					<li>大数据</li>
					<li>精准分析</li>
					<li>智能匹配</li>
					<li>...</li>
				</ul>
			</div>
			<div>
				<h1>一</h1>
				<h3>第三方授权</h3>
				<ul>
					<li>微信</li>
					<li>微博</li>
					<li>抖音</li>
					<li>淘宝</li>
					<li>...</li>
				</ul>
			</div>
			<div>
				<h1>一</h1>
				<h3>服务类型</h3>
				<ul>
					<li>APP</li>
					<li>小程序</li>
					<li>h5公众号</li>
					<li>pc</li>
					<li>...</li>
				</ul>
			</div>
			<div>
				<h1>一</h1>
				<h3>高标准交付</h3>
				<ul>
					<li>源代码</li>
					<li>免费售后</li>
					<li>终身维护</li>
					<li>拒绝模板</li>
					<li>...</li>
				</ul>
			</div>
		</div>
	</div>
	<div class="xuqiu">
		<div class="content">
			<div class="box">
				<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/xuqiu.png" alt="" />
				<p>需求分析</p>
			</div>
			<span></span>
			<div class="box">
				<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/yuanxingsheji.png" alt="" />
				<p>原型设计</p>
			</div>
			<span></span>
			<div class="box">
				<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/uisheji.png" alt="" />
				<p>UI设计</p>
			</div>
			<span></span>
			<div class="box">
				<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/chengxukaifa.png" alt="" />
				<p>程序开发</p>
			</div>
			<span></span>
			<div class="box">
				<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/chanpintiaos.png" alt="" />
				<p>产品测试</p>
			</div>
			<span></span>
			<div class="box">
				<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/xiangmuguanli.png" alt="" />
				<p>项目管理</p>
			</div>
			<span></span>
			<div class="box">
				<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/zhengshushenqing.png" alt="" />
				<p>证书申请</p>
			</div>
			<span></span>
			<div class="box">
				<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/genxinweihu.png" alt="" />
				<p>更新维护</p>
			</div>
		</div>
	</div>
	<div class="serve">
		<h1>服务领先，专业更值得信赖</h1>
		<p>提供移动端产品专属定制开发服务，四大优势，放心可靠</p>
		<div class="content">
			<div class="top">
				<div>
					<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/pinfw.png" alt="" />
					<h3>拼服务</h3>
					<p>
						每个项目都会成立专用组进行沟通，资深产品经理对全程流程进行跟踪，实时把控项目进度和质量。
					</p>
				</div>
				<div>
					<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/jiangzhiliang.png" alt="" />
					<h3>讲质量</h3>
					<p>
						每个项目专职项目经理，实时把控项目细节，内部行程品控闭环，保障项目最终的效果和质量。
					</p>
				</div>
				<div>
					<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/pinxiaolu.png" alt="" />
					<h3>拼效率</h3>
					<p>
						项目均安排团队进行制作和把控，以便达到工期短、质量高、服务好的最终效果
					</p>
				</div>
				<div>
					<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/pinfw.png" alt="" />
					<h3>拼方案</h3>
					<p>资深大厂产品经理，不断深入调研，最快速提供完整的项目方案。</p>
				</div>
			</div>
			<div class="bottom">
				<div>
					<h3>01</h3>
					<span>打造企业无形竞争力</span>
					<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/fuwu01.png" alt="" />
					<h5>APP定制开发</h5>
					<p>
						兼容IOS、Android双系统开发，注重移动触点的UI用户体验，细致严谨的开发程序，成功经验分享与借鉴，快速助推产品落地
					</p>
				</div>
				<div>
					<h3>02</h3>
					<span>基于小程序高传播接口开发</span>
					<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/fuwu02.png" alt="" />
					<h5>小程序/公众号开发</h5>
					<p>
						微信小程序、支付宝小程序、百度小程序、抖音小程序拥有庞大的用户基数，再根据客户的运营推广要求，开发小程序、公众号服务号等
					</p>
				</div>
				<div>
					<h3>03</h3>
					<span>为您量身定制电脑端系统</span>
					<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/fuwu03.png" alt="" />
					<h5>H5/PC端开发</h5>
					<p>
						根据企业实际业务发展要求，提供一体化的互联网+技术解决方案，让您的项目从概念到产品，快速启动、轻松落地
					</p>
				</div>
				<div>
					<h3>04</h3>
					<span>为您设计专属界面，拒绝模板</span>
					<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/fuwu04.png" alt="" />
					<h5>UI设计</h5>
					<p>APP界面设计，网页界面设计，高端专业定制属于您的APP</p>
				</div>
			</div>
		</div>
	</div>
	<div class="vision">
		<h1>与远见者前行</h1>
		<p>同追求极致的企业合作，创造有影响力的产品</p>
		<div class="content" ref="rightContent" @mousewheel="scroll">
			<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/hyyslog.png" />
			<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/tcytlog.png" />
			<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/jljklog.png" />
			<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/jzhzlog.png" />
			<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/yhfllog.png" />
			<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/jscwlog.png" />
			<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/hyqilog.png" />
			<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/hyyslog.png" />
			<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/tcytlog.png" />
			<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/jljklog.png" />
			<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/jzhzlog.png" />
			<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/yhfllog.png" />
			<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/jscwlog.png" />
			<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/hyqilog.png" />
		</div>
	</div>
	<Footer></Footer>
	<Floating></Floating>
	<Onlineservice></Onlineservice>
</template>

<script>
	import Nav from "./Nav.vue";
	import Footer from "./Footer.vue";
	import Onlineservice from "./Onlineservice.vue";
	import Floating from "./Floating.vue";
	export default {
		name: "Solve",
		components: {
			Nav,
			Footer,
			Floating,
			Onlineservice,
		},
		data() {
			return {
				currentIndex: 0,
				imgUrls: [
					"static/img/hyyslog.c5d5db34.png",
					"static/img/tcytlog.8a1ee9cc.png",
					"static/img/jljklog.4fb92789.png",
					"static/img/jzhzlog.42ece047.png",
					"static/img/yhfllog.7689bc6d.png",
					"static/img/jscwlog.33058414.png",
					"static/img/hyqilog.7ce1de14.png",
					"static/img/hyyslog.c5d5db34.png",
					"static/img/tcytlog.8a1ee9cc.png",
					"static/img/jljklog.4fb92789.png",
					"static/img/jzhzlog.42ece047.png",
					"static/img/yhfllog.7689bc6d.png",
					"static/img/jscwlog.33058414.png",
					"static/img/hyqilog.7ce1de14.png",
				],
				scrollLeft: 0,
				maxWidth: 0,
				zhangtai: true,
			};
		},
		mounted() {
			this.$refs.rightContent.addEventListener("scroll", this.scrool);
			this.autoPlay();
		},
		methods: {
			scrool() {
				console.log("===scrool===");
				let scrolled = this.$refs.rightContent.scrollLeft;
				this.maxWidth =
					this.$refs.rightContent.scrollWidth - this.$refs.rightContent.clientWidth;
			},

			autoPlay() {
				setInterval(() => {
					this.setIndex();
				}, 8);
			},
			setIndex() {
				this.$refs.rightContent.scrollLeft++;
				if (this.$refs.rightContent.scrollLeft >= this.maxWidth - 264) {
					this.$refs.rightContent.scrollLeft = 0;
				}
			},
		},
	};
</script>

<style lang="less" scoped>
	.header {
		width: 100%;
		height: 520px;
		background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/solve.png) no-repeat;
		background-size: cover;

		.content {
			width: 1440px;
			height: 400px;
			margin: 0 auto;
			/* background-color: white; */
			overflow: hidden;
			color: white;

			h3 {
				height: 50px;
				line-height: 50px;
				font-size: 36px;
				margin-top: 100px;
				font-weight: 540;
			}

			p {
				height: 50px;
				line-height: 50px;
				font-size: 22px;
				margin-top: 20px;
				font-weight: 400;
			}
		}
	}

	.customization {
		width: 100%;
		height: 1005px;
		background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/dingzbg.png) no-repeat;
		background-size: cover;
		overflow: hidden;

		h3 {
			width: 612px;
			height: 50px;
			font-size: 36px;
			font-weight: 400;
			line-height: 50px;
			color: #333333;
			margin: 0 auto;
			margin-top: 120px;
		}

		.content {
			width: 1440px;
			height: 700px;
			margin: 0 auto;
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-top: 60px;

			.left {
				width: 450px;
				height: 700px;
				//   background-color: red;
				overflow: hidden;

				h4 {
					margin-top: 150px;
					width: 240px;
					height: 50px;
					font-size: 30px;
					font-weight: 400;
					line-height: 50px;
					color: #333333;
				}

				h2 {
					width: 320px;
					height: 30px;
					font-size: 20px;
					font-weight: 400;
					line-height: 30px;
					font-weight: 400;
					color: #333333;
				}

				p {
					width: 351px;
					height: 56px;
					font-size: 14px;
					font-weight: 400;
					line-height: 21px;
					color: #999999;
					opacity: 1;
					margin-top: 60px;
				}

				h5 {
					width: 400px;
					height: 14px;
					font-size: 14px;
					font-weight: 400;
					line-height: 0px;
					color: #333333;
					opacity: 1;
					margin-top: 180px;
				}

				img {
					margin-top: 10px;
					display: block;
					width: 440px;
					height: 33px;
				}
			}

			.right {
				width: 1041px;
				height: 700px;

				//   background: #333333;
				img {
					display: block;
					width: 100%;
					height: 100%;
				}
			}
		}
	}

	.technology {
		position: relative;
		width: 100%;
		height: 500px;
		background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/yixiao.png) no-repeat;
		background-size: cover;
		display: inline-block;

		h2 {
			width: 612px;
			height: 50px;
			font-size: 36px;
			font-weight: 500;
			line-height: 50px;
			color: #ffffff;
			margin: 0 auto;
			text-align: center;
			margin-top: 120px;
		}

		p {
			width: 640px;
			height: 22px;
			font-size: 16px;
			font-weight: 400;
			line-height: 30px;
			color: #ffffff;
			opacity: 1;
			margin: 0 auto;
			text-align: center;
			margin-top: 30px;
		}

		.content {
			position: absolute;
			width: 1440px;
			height: 205px;
			left: 0;
			right: 0;
			margin: 0 auto;
			display: flex;
			bottom: -60px;

			div {
				width: 205px;
				height: 205px;
				background: #ffffff;
				border: 1px solid #e8ebf1;
				box-sizing: border-box;
				border-radius: 3px;
				transition: all 0.25s ease-in;

				h1 {
					width: 112px;
					height: 22px;
					font-size: 16px;
					font-weight: bold;
					line-height: 22px;
					color: #ffffff;
					opacity: 1;
					margin-top: 20px;
					margin-left: 30px;
				}

				h3 {
					margin-left: 30px;
					width: 120px;
					height: 22px;
					font-size: 16px;
					font-weight: bold;
					line-height: 22px;
					color: #333333;
					opacity: 1;
				}

				ul {
					margin-top: 20px;
					margin-left: 30px;
				}

				ul>li {
					width: 120px;
					height: 20px;
					font-size: 14px;
					font-weight: 400;
					line-height: 20px;
					color: #333333;
					opacity: 0.6;
				}
			}

			div:hover {
				height: 280px;
				background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/dyh.png) no-repeat;
				background-size: cover;
				transform: translateY(-60px);
				border: 0px solid #e8ebf1;

				h1 {
					margin-top: 50px;
				}

				h3 {
					color: #ffffff;
				}

				ul>li {
					color: #ffffff;
				}
			}
		}
	}

	.xuqiu {
		width: 100%;
		height: 400px;
		background: #e8ebf1;

		.content {
			width: 1440px;
			height: 400px;
			margin: 0 auto;
			display: flex;
			justify-content: space-around;
			align-items: center;

			.box {
				width: 100px;
				height: 400px;
				//   background: #333333;
				overflow: hidden;

				img {
					display: block;
					width: 88px;
					height: 88px;
					margin: 0 auto;
					margin-top: 170px;
				}

				p {
					width: 80px;
					height: 20px;
					font-size: 20px;
					font-weight: 400;
					line-height: 20px;
					color: #333333;
					opacity: 1;
					margin: 0 auto;
					margin-top: 30px;
				}
			}

			span {
				display: block;
				width: 70px;
				height: 0px;
				background: #ffffff;
				border-bottom: 1px dashed #e71115;
				opacity: 0.1;
				border-radius: 0px;
				margin-top: 20px;
			}
		}
	}

	.serve {
		width: 100%;
		height: 1080px;
		background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/dabg.png) no-repeat;
		background-size: cover;
		display: inline-block;

		// overflow: hidden;
		h1 {
			width: 602px;
			height: 60px;
			font-size: 36px;
			font-weight: 500;
			line-height: 60px;
			color: #333333;
			opacity: 1;
			margin: 0 auto;
			text-align: center;
			margin-top: 80px;
		}

		p {
			width: 600px;
			height: 30px;
			font-size: 16px;
			font-weight: 400;
			line-height: 30px;
			color: #333333;
			opacity: 1;
			margin: 0 auto;
			text-align: center;
			margin-top: 20px;
		}

		.content {
			width: 1440px;
			height: 1000px;
			margin: 0 auto;
			// background: #e8ebf1;
			position: relative;

			.top {
				width: 1440px;
				height: 280px;
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin-top: 50px;

				div {
					width: 250px;
					height: 280px;

					// background: red;
					img {
						display: block;
						width: 88px;
						height: 88px;
						margin: 10px auto;
					}

					h3 {
						width: 100%;
						height: 30px;
						font-size: 16px;
						font-weight: 600;
						line-height: 30px;
						color: #333333;
						opacity: 1;
						margin: 10px auto;
						text-align: center;
					}

					p {
						width: 240px;
						height: 20px;
						font-size: 14px;
						font-weight: 400;
						line-height: 20px;
						color: #666666;
						opacity: 1;
						margin: 10px auto;
						text-align: center;
					}
				}
			}

			.bottom {
				width: 1440px;
				height: 600px;
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin-top: 10px;
				position: absolute;

				div {
					overflow: hidden;
					width: 340px;
					height: 530px;
					background: #ffffff;
					box-shadow: 0px 3px 12px rgba(153, 153, 153, 0.16);
					opacity: 1;
					border-radius: 5px;
					transition: all 0.5s ease;

					h3 {
						width: 35px;
						height: 40px;
						font-size: 32px;
						font-weight: bold;
						line-height: 40px;
						color: #333333;
						opacity: 1;
						margin: 40px 0 10px 10px;
					}

					span {
						width: 126px;
						height: 20px;
						font-size: 14px;
						font-weight: 400;
						line-height: 20px;
						color: #666666;
						opacity: 0.8;
						margin: 0 0 0 10px;
					}

					img {
						width: 320px;
						height: 240px;
						display: block;
						margin: 10px auto;
					}

					h5 {
						width: 200px;
						height: 20px;
						font-size: 16px;
						font-weight: bold;
						line-height: 20px;
						color: #333333;
						opacity: 1;
						margin: 30px 0 0px 10px;
					}

					p {
						width: 320px;
						height: 20px;
						font-size: 14px;
						font-weight: 400;
						line-height: 20px;
						color: #666666;
						opacity: 1;
						text-align: left;
						margin-top: 5px;
					}
				}

				div:hover {
					width: 340px;
					height: 530px;
					background: #e71115;
					box-shadow: 0px 3px 12px rgba(231, 17, 21, 0.25);
					opacity: 1;
					border-radius: 5px;

					h3 {
						color: #ffffff;
					}

					span {
						color: #ffffff;
						opacity: 0.8;
					}

					h5 {
						color: #ffffff;
					}

					p {
						color: #ffffff;
						opacity: 0.8;
					}
				}
			}
		}
	}

	.vision {
		width: 100%;
		height: 900px;
		background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/damuzibg.png) no-repeat;
		background-size: cover;

		h1 {
			width: 100%;
			height: 50px;
			font-size: 36px;
			font-weight: 500;
			line-height: 50px;
			color: #333333;
			margin: 0 auto;
			margin-top: 150px;
			text-align: center;
		}

		p {
			width: 320px;
			height: 30px;
			font-size: 16px;
			font-weight: 400;
			line-height: 30px;
			color: #333333;
			opacity: 1;
			margin: 0 auto;
			text-align: center;
			margin-top: 30px;
		}

		.content {
			width: 100%;
			height: 600px;
			display: flex;
			// justify-content: center;
			overflow-x: hidden;
			margin-top: 50px;

			img {
				display: block;
				width: 320px;
				height: 320px;
			}
		}
	}
</style>